





































































































































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GFrameFormInput',
  props: {
    value: { type: Number as PropType<number>, default: null },
    addParts: {
      type: Function as PropType<() => void>,
    },
    addDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
});
